import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
const Loader = ({ size = 24 }) => (React.createElement(Spin, { indicator: React.createElement(LoadingOutlined, { style: { fontSize: size }, spin: true }) }));
export default Loader;
